import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUser, faSitemap } from "@fortawesome/free-solid-svg-icons"

interface Props {
  unitName: string
  unitSize?: number | null
  isCurrentUnit?: boolean
  isClickable?: boolean
  onClick?: () => void
}

export default function UnitBadge({ unitName, unitSize, isCurrentUnit = false, isClickable = true, onClick }: Props) {
  const baseClass = "text-xs px-3 py-1.5 rounded font-medium grid gap-x-2 items-center"
  const gridCols = unitSize != null ? "auto 1fr auto" : "auto 1fr"

  if (isCurrentUnit) {
    return (
      <div
        className={`${baseClass} text-white ${isClickable ? "cursor-pointer" : "cursor-default"}`}
        style={{ backgroundColor: "#999", gridTemplateColumns: gridCols }}
        onClick={isClickable ? onClick : undefined}>
        <FontAwesomeIcon icon={faSitemap} size="sm" />
        <span>{unitName}</span>
        {unitSize != null && (
          <span className="flex items-center gap-1 whitespace-nowrap">
            <FontAwesomeIcon icon={faUser} size="sm" /> {unitSize}
          </span>
        )}
      </div>
    )
  }

  return (
    <div
      className={`${baseClass} bg-white ${isClickable ? "cursor-pointer hover:bg-gray-50 transition" : "cursor-default"}`}
      style={{ border: "1px solid #999", color: "#999", gridTemplateColumns: gridCols }}
      onClick={isClickable ? onClick : undefined}>
      <FontAwesomeIcon icon={faSitemap} size="sm" />
      <span>{unitName}</span>
      {unitSize != null && (
        <span className="flex items-center gap-1 whitespace-nowrap">
          <FontAwesomeIcon icon={faUser} size="sm" /> {unitSize}
        </span>
      )}
    </div>
  )
}
